<template>
    <div class="black-bg">
        <div v-if="!isLoading">
            <div v-if="subscribe != null">
                <DetailInfo
                    class="layout-info"
                    :lbl="lbl"
                    :campaign="subscribe"
                    :isSubscription="true"
                    :hideCondition="true"
                    backRoute="/menu"
                ></DetailInfo>
                <Footer
                    layout="fade"
                    text="Subscribe Now"
                    action="next"
                    path="subscriptionform"
                ></Footer>
            </div>
        </div>
    </div>
</template>

<script>
//components
import DetailInfo from "@/module/Detail/component/detail/DetailInfo.vue";
import Footer from "@/module/Subscription/components/Footer.vue";
//mixin
import Mixin from "@/mixin/Mixin";
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//vuex
import { mapGetters, mapActions } from "vuex";
//core
import { CategoryConfigBuilder } from "@/core/Campaign/model/CategoryConfigModel.js";
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";
//helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
//config
import ConfigManager from "@/config/ConfigManager.js";

export default {
    name: "SubscriptionDetail",
    mixins: [Mixin, AccountMixin, LocaleMixin],
    components: {
        DetailInfo,
        Footer
    },
    computed: {
        ...mapGetters(["getUserSubscription"])
    },
    data() {
        return {
            subscribe: {
                name: "",
                fullImageUrl: [],
                detail: ""
            },
            campaign: {},
            subscriptionConfig: {},
            strBzbsToken: Account.getToken(),
            locale: Locale.getLocaleCode(),
            isLoading: false
        };
    },
    created() {
        this.handleLoading(true);
        this.resetUserSubscritionData();
        this.isLoading = true;
        if (!this.getUserSubscription.campaign.campaign) {
            this.setConfig();
            this.getList();
        } else {
            this.campaign = this.getUserSubscription.campaign.campaign;
            this.setupPage();
        }
    },
    methods: {
        ...mapActions(["setCampaignSubscription", "setUserSubscription"]),
        setConfig() {
            var configSubScriptionStr = ConfigManager.getSubscriptionMenu();
            this.categoryConfig = new CategoryConfigBuilder()
                .setConfig(configSubScriptionStr)
                .setLocale(this.locale)
                .create();
        },
        resetUserSubscritionData() {
            this.setUserSubscription({});
        },
        getList() {
            return new Promise(resolve => {
                var categoryParam = this.categoryConfig.getParams();
                var token = Account.getToken();
                BzbsCategory.apiGetCategory(token, categoryParam).subscribe(
                    categories => {
                        console.log(categories);
                        for (let i = 0; i < categories.length; i++) {
                            if (
                                categories[i].id ==
                                this.$route.params.campaignId
                            ) {
                                this.campaign = categories[i];
                            }
                        }
                        this.setCampaignSubscription({
                            campaign: this.campaign
                        });
                        this.setupPage();
                        this.handleLoading(false);
                        this.isLoading = false;
                        resolve(this.campaign);
                    },
                    err => {
                        this.isLoading = false;
                        this.handleLoading(false);
                        console.log(err);
                    }
                );
            });
        },
        setupPage() {
            this.subscribe.name = this.campaign.name_th;
            this.subscribe.id = this.campaign.id;
            this.subscribe.fullImageUrl.push(this.campaign.image_url);
            this.subscribe.detail = this.campaign.detail;
            if (this.getUserSubscription.campaign.campaign) {
                this.handleLoading(false);
                this.isLoading = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.black-bg {
    background-color: #000;
}
</style>
